import { Link } from "react-router-dom";
import tag from "../../../assets/icons/tag.svg";
import profile from "../../../assets/icons/profileGrey.svg";

const CampaignCard = ({
  campaignImage,
  campaignTitle,
  campaignOwnerFirstName,
  campaignOwnerLastName,
  amountRaised,
  campaignGoal,
  category,
  progress,
  campaignID,
  email
}) => {
  return (
        <Link to={`/campaign-detail/${campaignID}`} className="flex md:grid items-center gap-4 md:gap-2">
          <div className="overflow-hidden rounded border w-[35%] md:w-full aspect-square md:aspect-video">
            <img
              src={campaignImage}
              alt="campaign_image"
              className="w-full h-full object-cover rounded hover:scale-105 transition-transform duration-1000"
            />
          </div>
          <div className="truncate w-[55%] md:w-full">
            <p className="truncate font-medium text-sm capitalize">{campaignTitle}</p>
            <p className="text-sm text-secondary truncate flex items-center gap-2 mt-2 md:mt-0">
              <div className="hidden md:block">Campaign owner:</div>
              <img src={profile} className="h-4 md:hidden" alt="" />
              <Link to={`/campaigns/${btoa(email)}`} className="flex gap-[3px] truncate">
                <span>{campaignOwnerFirstName}</span>
                <span className="truncate">{campaignOwnerLastName}</span>
              </Link>
            </p>
            <div className="grid gap-1 mt-3">
              <div className="w-full rounded-md bg-secondaryBackground p-[2px] flex items-center">
                <div className="bg-brandGreen h-[2px] transition-all"  style={{ width: progress }}></div>
              </div>
              <p className="truncate text-sm">
                <span className="font-bold">&#8358;{amountRaised}</span> raised out of &#8358;{campaignGoal}
              </p>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <img src={tag} alt="" className="h-4"/>
              <span className="text-[13px] text-secondary">{category}</span>
            </div>
          </div>
        </Link>
  );
};

export default CampaignCard;
